import React, { useState } from 'react';
import './SPPLStyles.css';

const SPPLGenerator = () => {
  const [formData, setFormData] = useState({
    nama: '',
    nib: '',
    alamat: '',
    telepon: '',
    email: '',
    kodeKbli: '',
    judulKbli: '',
    ruangLingkup: '',
    risiko: '',
    nku: '',
    lokasiUsaha: '',
    jenisDokumen: '', 
    sumberPenapisan: '',
    kota: '',
    tanggalTerbit: '',
    tanggalPerbarui: '' 
  });

  const [signatureImg, setSignatureImg] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSignatureImg(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="container">
      
      {/* --- BAGIAN KIRI: FORMULIR */}
      <div className="form-section no-print">
        
        <div style={{marginBottom: '30px', borderBottom: '1px solid #eee', paddingBottom: '20px'}}>
            <h2 style={{margin: '0', color: '#2c3e50', fontSize: '24px'}}>🌿 Generator SPPL</h2>
            <p style={{margin: '5px 0 0 0', color: '#7f8c8d'}}>Buat dokumen SPPL standar OSS dengan mudah.</p>
        </div>

        {/* CARD 1: IDENTITAS */}
        <div className="input-card">
            <div className="card-header">
                <span className="card-icon">👤</span>
                <h3>Identitas Pelaku Usaha</h3>
            </div>
            <div className="form-group">
                <label>Nama Lengkap</label>
                <input type="text" name="nama" value={formData.nama} onChange={handleChange} placeholder="Contoh: Budi Santoso" />
            </div>
            <div className="form-group">
                <label>Nomor Induk Berusaha (NIB)</label>
                <input type="text" name="nib" value={formData.nib} onChange={handleChange} />
            </div>
            <div className="form-group">
                <label>Alamat Usaha</label>
                <textarea name="alamat" value={formData.alamat} onChange={handleChange} placeholder="Alamat lengkap..." rows="2" />
            </div>
            <div className="grid-2">
                <div className="form-group">
                    <label>No. Telepon</label>
                    <input type="text" name="telepon" value={formData.telepon} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Email</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} />
                </div>
            </div>
        </div>

        {/* CARD 2: KBLI & TEKNIS */}
        <div className="input-card">
            <div className="card-header">
                <span className="card-icon">🏭</span>
                <h3>Data Kegiatan (KBLI)</h3>
            </div>
            <div className="grid-2">
                <div className="form-group">
                    <label>Kode KBLI</label>
                    <input type="text" name="kodeKbli" value={formData.kodeKbli} onChange={handleChange}/>
                </div>
                <div className="form-group">
                    <label>Judul KBLI</label>
                    <input type="text" name="judulKbli" value={formData.judulKbli} onChange={handleChange} />
                </div>
            </div>
            <div className="form-group">
                <label>Ruang Lingkup Kegiatan</label>
                <input type="text" name="ruangLingkup" value={formData.ruangLingkup} onChange={handleChange} />
            </div>
            <div className="grid-2">
                <div className="form-group">
                    <label>Tingkat Risiko Kegiatan Usaha</label>
                    <input type="text" name="risiko" value={formData.risiko} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Nomor Kegiatan Usaha (NKU)</label>
                    <input type="text" name="nku" value={formData.nku} onChange={handleChange} />
                </div>
            </div>
            <div className="form-group">
                <label>Lokasi Kegiatan Usaha</label>
                <input type="text" name="lokasiUsaha" value={formData.lokasiUsaha} onChange={handleChange} />
            </div>
            <div className="grid-2">
                <div className="form-group">
                    <label>Jenis Dokumen Lingkungan Hidup</label>
                    <input type="text" name="jenisDokumen" value={formData.jenisDokumen} onChange={handleChange} placeholder="Cth: SPPL" />
                </div>
                <div className="form-group">
                    <label>Sumber Penapisan Jenis Dokumen Lingkungan Hidup</label>
                    <input type="text" name="sumberPenapisan" value={formData.sumberPenapisan} onChange={handleChange} placeholder="Cth: OSS..." />
                </div>
            </div>
        </div>

        {/* CARD 3: FOOTER & TTD */}
        <div className="input-card">
            <div className="card-header">
                <span className="card-icon">✍️</span>
                <h3>Tanda Tangan</h3>
            </div>
            <div className="form-group">
                <label>Upload Foto Tanda Tangan (Background Putih)</label>
                <input type="file" accept="image/*" onChange={handleImageUpload} />
            </div>
            <div className="grid-2">
                 <div className="form-group">
                    <label>Kota</label>
                    <input type="text" name="kota" value={formData.kota} onChange={handleChange} />
                 </div>
                 <div className="form-group">
                    <label>Tanggal Terbit</label>
                    <input type="text" name="tanggalTerbit" value={formData.tanggalTerbit} onChange={handleChange} />
                 </div>
            </div>
            <div className="form-group">
                 <label>Diperbarui Terakhir</label>
                 <input type="text" name="tanggalPerbarui" value={formData.tanggalPerbarui} onChange={handleChange} />
            </div>
        </div>

        <button className="btn-download" onClick={handlePrint}>
            🖨️ Cetak / Download PDF
        </button>
        <div style={{height: '50px'}}></div> 
      </div>

      {/* --- BAGIAN KANAN: PREVIEW --- */}
      <div className="document-preview">
        {/* === HALAMAN 1 === */}
        <div className="a4-page">
          <h3 style={{textAlign: 'center', fontWeight: 'bold'}}>SURAT PERNYATAAN KESANGGUPAN PENGELOLAAN DAN PEMANTAUAN LINGKUNGAN HIDUP (SPPL)</h3>
          <p>Kami yang bertanda tangan di bawah ini:</p>
          <table className="info-table">
            <tbody>
              <tr><td style={{width: '200px'}}>Nama Pelaku Usaha</td><td>: {formData.nama}</td></tr>
              <tr><td>Nomor Induk Berusaha (NIB)</td><td>: {formData.nib}</td></tr>
              <tr><td>Alamat</td><td>: {formData.alamat}</td></tr>
              <tr><td>No. Telepon</td><td>: {formData.telepon}</td></tr>
              <tr><td>Email</td><td>: {formData.email}</td></tr>
            </tbody>
          </table>
          <p>Dengan rincian kegiatan usaha, jenis Dokumen Lingkungan Hidup, Persetujuan Teknis dan Data Persetujuan Lingkungan sebagai berikut:</p>
          <h4 className="section-title">I. JENIS DOKUMEN LINGKUNGAN HIDUP</h4>
          <table className="kbli-table">
            <thead>
                <tr>
                    <th>Kode KBLI</th><th>Judul KBLI</th><th>Ruang Lingkup Kegiatan</th>
                    <th>Tingkat Risiko Kegiatan Usaha</th><th>Nomor Kegiatan Usaha (NKU)</th><th>Lokasi Kegiatan Usaha</th>
                    <th>Jenis Dokumen Lingkungan Hidup</th><th>Sumber Penapisan Jenis Dokumen Lingkungan Hidup</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{formData.kodeKbli}</td><td>{formData.judulKbli}</td>
                    <td>{formData.ruangLingkup}</td><td>{formData.risiko}</td>
                    <td>{formData.nku}</td><td>{formData.lokasiUsaha}</td>
                    <td>{formData.jenisDokumen}</td><td>{formData.sumberPenapisan}</td>
                </tr>
            </tbody>
          </table>
          <h4 className="section-title">II. PERSETUJUAN TEKNIS</h4>
          <table className="kbli-table">
            <thead><tr><th>No.</th><th>Persetujuan Teknis Wajib</th><th>Wajib</th><th>Tidak Wajib</th><th>Sumber Penapisan Persetujuan Teknis</th></tr></thead>
            <tbody><tr><td colSpan="5" style={{textAlign: 'center'}}>Tidak ada Data Teknis</td></tr></tbody>
          </table>
          <h4 className="section-title">III. DATA PERSETUJUAN LINGKUNGAN</h4>
          <p style={{marginBottom: '5px'}}> Dalam Proses</p>
          <p>Menyatakan kesanggupan:</p>
          <ol className="commitment-list">
             <li>Mematuhi dan melaksanakan kegiatan usaha pada lokasi yang sesuai dengan peruntukan dalam rencana tata ruang;</li>
             <li>Mematuhi dan melaksanakan kegiatan usaha sesuai dengan ketentuan peraturan perundang-undangan di bidang perlindungan dan pengelolaan lingkungan hidup;</li>
             <li>Mematuhi ketentuan persyaratan pemenuhan parameter baku mutu lingkungan sesuai dengan kegiatan usaha yang dilakukan serta limbah yang dihasilkan;</li>
             <li>Mematuhi ketentuan dan menyediakan fasilitas penyimpanan limbah sementara dan sampah domestik sesuai dengan kegiatan usaha serta limbah dan sampah yang dihasilkan;</li>
             <li>Mematuhi ketentuan dan menyediakan fasilitas pengelolaan limbah cair untuk kegiatan usaha yang dilakukan sesuai dengan jumlah limbah yang dihasilkan dan jumlah tenaga kerjanya;</li>
             <li>Bersedia untuk menyediakan fasilitas pengelolaan air limbah sesuai ketentuan yang berlaku dalam hal pelaku usaha berencana melakukan pembuangan air limbah ke badan air atau ke perairan laut;</li>
          </ol>
        </div>

        {/* === HALAMAN 2 === */}
        <div className="a4-page">
          <ol className="commitment-list" start="7">
             <li>Bersedia untuk melakukan pengelolaan emisi dalam hal usaha menghasilkan emisi sesuai ketentuan yang berlaku;</li>
             <li>Bersedia untuk memenuhi pengaturan dan pengelolaan dampak kegiatan usaha terhadap aspek transportasi;</li>
             <li>Bersedia dilakukan pemeriksaan/pengawasan terhadap kegiatan usaha yang dilakukan untuk memastikan pemenuhan persyaratan lingkungan sesuai ketentuan peraturan perundang-undangan di bidang perlindungan dan pengelolaan lingkungan hidup;</li>
             <li>Bersedia memproses Persetujuan Lingkungan sesuai dengan Dokumen Lingkungan Hidup yang tertera dalam SPPL ini;</li>
             <li>Bersedia memproses Persetujuan Teknis yang diwajibkan dalam SPPL ini; dan</li>
             <li>Bersedia untuk:
                <ul style={{listStyleType: 'lower-alpha', marginLeft: '20px'}}>
                   <li>mendapatkan teguran tertulis;</li>
                   <li>diberhentikan kegiatan usahanya;</li>
                   <li>dikenai denda administratif;</li>
                   <li>dicabut perizinan berusahanya; dan/atau</li>
                   <li>dikenai sanksi-sanksi lain sesuai ketentuan peraturan perundang-undangan yang berlaku apabila melanggar atau tidak memenuhi ketentuan persyaratan yang telah ditetapkan sebagaimana butir 1 sampai 11.</li>
                </ul>
             </li>
          </ol>
          <p>Demikian pernyataan ini dibuat dengan sebenar-benarnya dengan data dukung berupa data kegiatan usaha yang telah kami isikan/unggah dalam sistem OSS. Apabila di kemudian hari didapati terdapat kekeliruan ataupun ketidakakuratan dalam pernyataan ini, maka kami bersedia menerima konsekuensi sesuai dengan ketentuan peraturan perundang-undangan.</p>
          
          <div className="footer-container">
            <div className="footer-left">
                <p>Terbit : {formData.tanggalTerbit}</p>
                <p>Diperbarui terakhir : {formData.tanggalPerbarui}</p>
            </div>
            <div className="footer-right">
                <p>{formData.kota}, {formData.tanggalTerbit}</p>
                <p>Pelaku Usaha</p>
                <div className="signature-area">
                    {signatureImg ? ( <img src={signatureImg} alt="Tanda Tangan" className="signature-img" /> ) : ( <div className="signature-placeholder"></div> )}
                </div>
                <p>({formData.nama})</p>
            </div>
          </div>
          <div className="oss-footer">
              Surat pernyataan ini tersimpan secara elektronik di dalam sistem OSS sebagai bagian tak terpisahkan dari perizinan berusaha untuk Nomor Induk Berusaha yang dimaksud.
          </div>
        </div>
      </div>
    </div>
  );
};

export default SPPLGenerator;